export const SUCCESS_SEARCH_PRIORITIES = "SUCCESS_SEARCH_PRIORITIES";
export const LOADING_SEARCH_PRIORITIES = "LOADING_SEARCH_PRIORITIES";
